export interface IMenuItem {
  id?: string;
  icon?: string;
  label: string;
  to: string;
  newWindow?: boolean;
  subs?: IMenuItem[];
}

const data: IMenuItem[] = [
{
  id: 'Sales',
  icon: 'iconsminds-digital-drawing',
  label: 'menu.Sales',
  to: '/app/Esale',
  subs: [
   
    {
      icon: 'simple-icon-user-follow',
      label: 'menu.Sales',
      to: '/app/Esale/Add',
      newWindow: false
    }
    
    ]
  }

  ]

export default data;
